<template>
    <NuxtLayout name="default">
        <div class="404-layout relative grid place-content-center overflow-hidden pt-12 md:pt-14 min-h-[400px] md:min-h-[600px] bg-blur">
            <div class="container m-auto w-full py-12 z-20 relative">
                <div class="flex flex-col justify-center max-w-3xl m-auto sm:items-center sm:text-center">
                    <h2 class="mb-3">{{ t('misc.404.headline') }}</h2>
                    <p class="mb-6">{{ t('misc.404.text1') }}</p>
                    <MiscLink to="/" class="btn btn-ghost w-fit pl-0 sm:pl-4">
                        <MiscIcon name="chevron-left" />
                        {{ t('misc.404.buttonText') }}
                    </MiscLink>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n'

const {t} = useI18n()
</script>